import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import style from "./MenuBar.module.css";
import logo from "./assets/logo.png";
import { useLocation } from "react-router-dom";
const MenuBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // 1. get from URL
  let mode = (params.get("mode") || "").toLowerCase();

  // 2. fallback to sessionStorage
  if (!mode) {
    mode = sessionStorage.getItem("mode") || "";
  }

  // 3. store if found in URL
  if (params.get("mode")) {
    sessionStorage.setItem("mode", mode);
  }

  const isEmbedded = mode === "embedded";

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <>
      {/* Show toggle button only on mobile */}
      {isMobile && (
        <button className={style.toggleBtn} onClick={toggleMenu}>
          {menuOpen ? "☰" : "☰"}
        </button>
      )}

      {/* Sidebar */}
      <div
        className={`${style.MenuBar} ${
          isMobile
            ? menuOpen
              ? style.menuOpen
              : style.menuClosed
            : style.desktopMenu
        }`}
      >
        {!isEmbedded && (
          <div className={style.menulogo}>
            <img src={logo} alt="Logo" style={{ height: "40px" }} />
          </div>
        )}
        <div className={style.MenuBarContainer}>
          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              isActive ? `${style.link} ${style.active}` : style.link
            }
            end
          >
            Dashboard
          </NavLink>
          <NavLink
            to="/vendordetails"
            className={({ isActive }) =>
              isActive ? `${style.link} ${style.active}` : style.link
            }
          >
            Vendor Details
          </NavLink>
          <NavLink
            to="/inwbooking"
            className={({ isActive }) =>
              isActive ? `${style.link} ${style.active}` : style.link
            }
          >
            ASN Status
          </NavLink>
          <NavLink
            to="/purchaseorder"
            className={({ isActive }) =>
              isActive ? `${style.link} ${style.active}` : style.link
            }
          >
            Open Purchase Order
          </NavLink>
          <NavLink
            to="/bookedinvoice"
            className={({ isActive }) =>
              isActive ? `${style.link} ${style.active}` : style.link
            }
          >
            Invoices
          </NavLink>
          <NavLink
            to="/creditdebit"
            className={({ isActive }) =>
              isActive ? `${style.link} ${style.active}` : style.link
            }
          >
            Credit/Debit Notes
          </NavLink>

          <NavLink
            to="/paymentrecived"
            className={({ isActive }) =>
              isActive ? `${style.link} ${style.active}` : style.link
            }
          >
            Payment Advice
          </NavLink>

          <NavLink
            to="/reports"
            className={({ isActive }) =>
              isActive ? `${style.link} ${style.active}` : style.link
            }
          >
            Reports
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default MenuBar;
